// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2025 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetAppSystemByIdRequestModel from '../../model/get-app-system-by-id-request-model';
import GetAppSystemByIdRequestDTO from '../dto/get-app-system-by-id-request-dto';
import dtoSchema from '../schemas/get-app-system-by-id-request-schema';

export default abstract class GetAppSystemByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetAppSystemByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetAppSystemByIdRequestDTO>): GetAppSystemByIdRequestModel;
  static toModel(dto: DeepPartial<GetAppSystemByIdRequestDTO> | undefined | null): GetAppSystemByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetAppSystemByIdRequestDTO> | undefined | null): GetAppSystemByIdRequestModel | undefined {
    return dto ? new GetAppSystemByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetAppSystemByIdRequestModel> | GetAppSystemByIdRequestModel): GetAppSystemByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetAppSystemByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetAppSystemByIdRequestModel, can not map to GetAppSystemByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
